import React, { useState } from "react";
import { Box, FormControl, Select, MenuItem, Typography, makeStyles } from "@material-ui/core";
import InProcessTestStatusTab from "./InProcessTestStatusTab";
import ProductReleaseTestStatusTab from "./ProductReleaseTestStatusTab";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  selectorContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  selectorLabel: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#333",
  },
  select: {
    minWidth: "250px",
  },
}));

const TestsTab = (props) => {
  const classes = useStyles();
  const [selectedTestType, setSelectedTestType] = useState("inProcess");

  const handleTestTypeChange = (event) => {
    setSelectedTestType(event.target.value);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.selectorContainer}>
        <Typography className={classes.selectorLabel}>Select Test Type:</Typography>
        <FormControl variant="outlined" size="small" className={classes.select}>
          <Select
            value={selectedTestType}
            onChange={handleTestTypeChange}
            displayEmpty
          >
            <MenuItem value="inProcess">In-Process Test</MenuItem>
            <MenuItem value="productRelease">Product Release Test</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {selectedTestType === "inProcess" ? (
        <InProcessTestStatusTab {...props} />
      ) : (
        <ProductReleaseTestStatusTab {...props} />
      )}
    </Box>
  );
};

export default TestsTab;

